import React from 'react';
import { MegaphoneIcon, UsersIcon, MapPinIcon, BanknoteIcon, CalendarIcon, TargetIcon } from 'lucide-react';
import { formatZAR } from '../hooks/useMavisData';
const campaigns = [{
  name: 'Youth Vendor Accelerator',
  status: 'Active',
  desc: 'Empowering youth under 35 to start their own vending businesses with subsidized setup costs.',
  target: 'Youth',
  enrolled: 45,
  budget: 500000,
  start: '2023-08-01',
  end: '2023-12-31',
  progress: 65
}, {
  name: 'Women in Energy',
  status: 'Active',
  desc: 'Supporting female entrepreneurs in the energy sector with higher commission tiers for the first 6 months.',
  target: 'Women',
  enrolled: 32,
  budget: 350000,
  start: '2023-09-15',
  end: '2024-03-15',
  progress: 40
}, {
  name: 'Township Enterprise',
  status: 'Upcoming',
  desc: 'Expanding vending networks in underserved township areas to improve accessibility.',
  target: 'Community',
  enrolled: 0,
  budget: 800000,
  start: '2023-11-01',
  end: '2024-05-01',
  progress: 0
}, {
  name: 'Digital Literacy for Vendors',
  status: 'Active',
  desc: 'Training program for informal vendors to use digital vending platforms effectively.',
  target: 'Community',
  enrolled: 120,
  budget: 150000,
  start: '2023-07-01',
  end: '2023-11-30',
  progress: 85
}, {
  name: 'Green Energy Champions',
  status: 'Upcoming',
  desc: 'Incentivizing vendors who promote energy-saving practices and smart meter adoption.',
  target: 'Community',
  enrolled: 0,
  budget: 250000,
  start: '2024-01-01',
  end: '2024-06-30',
  progress: 0
}, {
  name: 'Community Hub Network',
  status: 'Completed',
  desc: 'Establishing centralized vending hubs in community centers and libraries.',
  target: 'Community',
  enrolled: 12,
  budget: 450000,
  start: '2023-01-01',
  end: '2023-06-30',
  progress: 100
}];
const enrollments = [{
  vendor: 'Sipho Spaza Shop',
  campaign: 'Youth Vendor Accelerator',
  date: '2023-08-05',
  sales: 145000,
  status: 'Active'
}, {
  vendor: 'Mama Joy Supermarket',
  campaign: 'Women in Energy',
  date: '2023-09-16',
  sales: 85000,
  status: 'Active'
}, {
  vendor: 'Kasi Convenience',
  campaign: 'Youth Vendor Accelerator',
  date: '2023-08-12',
  sales: 115000,
  status: 'Active'
}, {
  vendor: 'Zanele Mini Market',
  campaign: 'Women in Energy',
  date: '2023-09-20',
  sales: 76000,
  status: 'Active'
}, {
  vendor: 'Thabo Electronics',
  campaign: 'Digital Literacy for Vendors',
  date: '2023-07-15',
  sales: 45000,
  status: 'Completed'
}, {
  vendor: 'Benoni Fresh Produce',
  campaign: 'Community Hub Network',
  date: '2023-02-10',
  sales: 210000,
  status: 'Completed'
}, {
  vendor: 'Dube Trading',
  campaign: 'Youth Vendor Accelerator',
  date: '2023-08-25',
  sales: 32000,
  status: 'At Risk'
}, {
  vendor: 'Mamelodi Super',
  campaign: 'Digital Literacy for Vendors',
  date: '2023-07-05',
  sales: 185000,
  status: 'Completed'
}];
export function CampaignPrograms() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-564">
      <div className="mb-8" data-id="element-565">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-566">
          Campaign Programs
        </h1>
        <p className="text-gray-500" data-id="element-567">
          Manage community vending programs for local economy participation and
          youth empowerment.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-568">
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-569">
          <div className="p-3 bg-mavis-teal/10 text-mavis-teal rounded-none" data-id="element-570">
            <MegaphoneIcon className="w-5 h-5" data-id="element-571" />
          </div>
          <div data-id="element-572">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-573">
              Active Campaigns
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-574">6</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-575">
          <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-576">
            <UsersIcon className="w-5 h-5" data-id="element-577" />
          </div>
          <div data-id="element-578">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-579">
              Youth Vendors
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-580">89</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-581">
          <div className="p-3 bg-mavis-blue/10 text-mavis-blue rounded-none" data-id="element-582">
            <MapPinIcon className="w-5 h-5" data-id="element-583" />
          </div>
          <div data-id="element-584">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-585">
              Communities Reached
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-586">12</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-587">
          <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-588">
            <BanknoteIcon className="w-5 h-5" data-id="element-589" />
          </div>
          <div data-id="element-590">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-591">
              Total Disbursed
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-592">
              {formatZAR(890000)}
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-593">
        {campaigns.map((camp, i) => <div key={i} className="bg-white rounded-none border border-gray-200 shadow-sm p-6 flex flex-col h-full" data-id="element-594">

            <div className="flex justify-between items-start mb-4" data-id="element-595">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-596">{camp.name}</h3>
              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium ${camp.status === 'Active' ? 'bg-green-100 text-green-800' : camp.status === 'Upcoming' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-597">

                {camp.status}
              </span>
            </div>
            <p className="text-sm text-gray-600 mb-6 flex-1" data-id="element-598">{camp.desc}</p>

            <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-599">
              <div className="flex items-center gap-2" data-id="element-600">
                <TargetIcon className="w-4 h-4 text-gray-400" data-id="element-601" />
                <span className="text-sm text-gray-700" data-id="element-602">{camp.target}</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-603">
                <UsersIcon className="w-4 h-4 text-gray-400" data-id="element-604" />
                <span className="text-sm text-gray-700" data-id="element-605">
                  {camp.enrolled} Enrolled
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-606">
                <BanknoteIcon className="w-4 h-4 text-gray-400" data-id="element-607" />
                <span className="text-sm font-mono text-gray-700" data-id="element-608">
                  {formatZAR(camp.budget)}
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-609">
                <CalendarIcon className="w-4 h-4 text-gray-400" data-id="element-610" />
                <span className="text-sm text-gray-700" data-id="element-611">
                  {camp.start.substring(5)} to {camp.end.substring(5)}
                </span>
              </div>
            </div>

            <div data-id="element-612">
              <div className="flex justify-between items-center mb-1" data-id="element-613">
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-614">
                  Progress
                </span>
                <span className="text-xs font-mono font-bold text-mavis-teal" data-id="element-615">
                  {camp.progress}%
                </span>
              </div>
              <div className="w-full bg-gray-100 h-2 rounded-none overflow-hidden" data-id="element-616">
                <div className={`h-full ${camp.status === 'Completed' ? 'bg-gray-400' : 'bg-mavis-teal'}`} style={{
              width: `${camp.progress}%`
            }} data-id="element-617" />

              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-618">
        <div className="p-5 border-b border-gray-200 bg-gray-50" data-id="element-619">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-620">
            Campaign Enrollment
          </h2>
        </div>
        <div className="overflow-x-auto" data-id="element-621">
          <table className="w-full text-left border-collapse" data-id="element-622">
            <thead data-id="element-623">
              <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-624">
                <th className="p-4 font-medium" data-id="element-625">Vendor Name</th>
                <th className="p-4 font-medium" data-id="element-626">Campaign</th>
                <th className="p-4 font-medium" data-id="element-627">Enrolled Date</th>
                <th className="p-4 font-medium text-right" data-id="element-628">
                  Sales Since Joining
                </th>
                <th className="p-4 font-medium" data-id="element-629">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-630">
              {enrollments.map((enroll, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-631">
                  <td className="p-4 text-sm font-medium text-gray-900" data-id="element-632">
                    {enroll.vendor}
                  </td>
                  <td className="p-4 text-sm text-gray-600" data-id="element-633">
                    {enroll.campaign}
                  </td>
                  <td className="p-4 text-sm text-gray-500" data-id="element-634">{enroll.date}</td>
                  <td className="p-4 text-sm font-mono font-bold text-gray-900 text-right" data-id="element-635">
                    {formatZAR(enroll.sales)}
                  </td>
                  <td className="p-4" data-id="element-636">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium ${enroll.status === 'Active' ? 'bg-green-100 text-green-800' : enroll.status === 'Completed' ? 'bg-gray-100 text-gray-800' : 'bg-red-100 text-red-800'}`} data-id="element-637">

                      {enroll.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}